import { getP } from 'redux-polyglot'
import api from '../libs/api'

/**
 * Actions for dismissing an error
 */
export const DISMISS_ERROR = 'RADIOS/DISMISS_ERROR'

export const dismissError = () => ({
  type: DISMISS_ERROR
})

/**
 * Actions for fetching radios from API
 */
export const FETCH_RADIOS_REQUEST = 'RADIOS/FETCH_REQUEST'
export const FETCH_RADIOS_SUCCESS = 'RADIOS/FETCH_SUCCESS'
export const FETCH_RADIOS_FAILURE = 'RADIOS/FETCH_FAILURE'

const fetchRadiosRequest = () => ({
  type: FETCH_RADIOS_REQUEST
})

const fetchRadiosSuccess = (genres, radios) => ({
  type: FETCH_RADIOS_SUCCESS,
  payload: {
    genres,
    radios
  }
})

const fetchRadiosFailure = error => ({
  type: FETCH_RADIOS_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true
})

export const loadRadios = () => (dispatch, getState) => {
  dispatch(fetchRadiosRequest())
  return api
    .getCustomRadios()
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          const genres = []
          const radios = {}
          for (let genre in response.customRadios) {
            genres[genre] = []
            response.customRadios[genre].forEach(radio => {
              const processed = {
                id: +radio.id,
                name: radio.name,
                desc: radio.description,
                img: radio.img.medium
              }
              genres[genre].push(processed.id)
              radios[processed.id] = processed
            })
          }
          return dispatch(fetchRadiosSuccess(genres, radios))
        } else {
          return dispatch(fetchRadiosFailure(response.reason))
        }
      },
      () =>
        dispatch(
          fetchRadiosFailure(
            getP(getState()).t('tv_radios.radios_loading_error', {
              _: 'An error occurred while loading the list of radios'
            })
          )
        )
    )
}

/**
 * Actions related to navigation
 */
export const SET_FOCUSED_GENRE = 'RADIOS/SET_FOCUSED_GENRE'
export const SET_FOCUSED_POSITION = 'RADIOS/SET_FOCUSED_POSITION'

export const setFocusedGenre = genre => ({
  type: SET_FOCUSED_GENRE,
  payload: {
    genre
  }
})
export const setFocusedPosition = (genre, position) => ({
  type: SET_FOCUSED_POSITION,
  payload: {
    genre,
    position
  }
})
